module.exports = require('./lib/core/core');


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/core.js
// module id = 1318
// module chunks = 0